export default __webpack_public_path__ + "static/media/collapse_arrow_up_icon.a7e37cc4.svg";